import Vue from "vue";
import Router from "vue-router";
import HomeView from "../views/HomeView.vue";
import CoreBusinessView from "../views/CoreBusinessView.vue";
import LabEquipmentView from "../views/LabEquipmentView.vue";
import TechnicalStyleView from "../views/TechnicalStyleView.vue";
import ReputationView from "../views/ReputationView.vue";
import HistoryView from "../views/HistoryView.vue";
import DigitalResultsView from "../views/DigitalResultsView.vue";
import PlatformEntriesView from "../views/PlatformEntriesView.vue";
import BusinessCategoriesView from "../views/BusinessCategoriesView.vue";
import BusinessDetailView from "../views/BusinessDetailView.vue";
import NewsView from "../views/NewsView.vue";
import NewsDetailView from "../views/NewsDetailView.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
      meta: { title: "易尤特集团" }
    },
    {
      path: "/core-business",
      name: "core-business",
      component: CoreBusinessView,
      meta: { title: "核心业务 - 易尤特集团" }
    },
    {
      path: "/lab-equipment",
      name: "lab-equipment",
      component: LabEquipmentView,
      meta: { title: "实验室设备 - 易尤特集团" }
    },
    {
      path: "/technical-style",
      name: "technical-style",
      component: TechnicalStyleView,
      meta: { title: "技术风采 - 易尤特集团" }
    },
    {
      path: "/reputation",
      name: "reputation",
      component: ReputationView,
      meta: { title: "口碑臻评 - 易尤特集团" }
    },
    {
      path: "/history",
      name: "history",
      component: HistoryView,
      meta: { title: "发展历程 - 易尤特集团" }
    },
    {
      path: "/digital-results",
      name: "digital-results",
      component: DigitalResultsView,
      meta: { title: "数字化成果 - 易尤特集团" }
    },
    {
      path: "/platforms",
      name: "platforms",
      component: PlatformEntriesView,
      meta: { title: "平台入口 - 易尤特集团" }
    },
    {
      path: "/news",
      name: "news",
      component: NewsView,
      meta: { title: "企业动态 - 易尤特集团" }
    },
    {
      path: "/news-detail",
      name: "news-detail",
      component: NewsDetailView,
      meta: { title: "企业动态详情 - 易尤特集团" }
    },
    {
      path: "/business-categories",
      name: "business-categories",
      component: BusinessCategoriesView,
      meta: { title: "核心业务分类 - 易尤特集团" }
    },
    {
      path: "/business-detail",
      name: "business-detail",
      component: BusinessDetailView,
      meta: { title: "业务详情 - 易尤特集团" }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
